import React from 'react'
import { useTranslation } from 'react-i18next'

// Compact list-row marker for a conversation handed off to staff. Blue on
// purpose: distinct from the orange "staff" mode pill (AI switched off) and
// the purple assignment pill — a handoff is a different state from both.
export default function HandoffPill({ handedOff }) {
  const { t } = useTranslation()
  if (!handedOff) return null
  return (
    <span
      className="pill"
      style={{ background: '#eff6ff', color: '#1d4ed8', fontSize: 10, whiteSpace: 'nowrap' }}
    >
      {t('inbox.handoffPill', { defaultValue: 'Waiting for staff' })}
    </span>
  )
}
